"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isExternalUrl = isExternalUrl;
function isExternalUrl(url) {
    try {
        const parsedUrl = new URL(url, window.location.origin);
        return parsedUrl.origin !== window.location.origin;
    }
    catch {
        return false;
    }
}
